import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { TabPanel, TabView } from 'primereact/tabview'

import { StatusTag } from '../../../../../../components/tableTemplates'
import { calculateBreakpointWidth } from '../../../../../../utils/helper/calculateBreakpointWidth'
import { useConfigContext } from '../../../../../ui-config/context'
import { useInvoiceItemById } from '../../../../data'
import { AllowanceCharges } from './AllowanceCharges'
import { InfoForm } from './InfoForm'

type Props = {
  visible: boolean
  setVisible: (params: boolean) => void
  setDisplayInfoItemAllowanceCharge: (params: boolean) => void
  setIdInfoItemAllowanceCharge: (params: string) => void
  invoiceId: string
  itemId: string
  currency: string
  setInfoModus: (params: boolean) => void
  infoActiveTabViewPanelIndex: number
  setInfoActiveTabViewPanelIndex: (params: number) => void
}

export const InfoInvoiceItem: React.FC<Props> = ({
  visible,
  setVisible,
  setDisplayInfoItemAllowanceCharge,
  setIdInfoItemAllowanceCharge,
  invoiceId,
  itemId,
  currency,
  setInfoModus,
  infoActiveTabViewPanelIndex,
  setInfoActiveTabViewPanelIndex,
}) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()

  const { data: invoiceItem, isLoading } = useInvoiceItemById(invoiceId, itemId)

  // ************************************************************
  // dialog components
  // ************************************************************
  // header
  const header = (
    <>
      <div className="flex align-content-center flex-wrap">
        <span className="mr-3">
          {t('invoice.invoiceItems.table.info.dialog.title', {
            position: invoiceItem?.OrderPosition,
          })}
        </span>

        <StatusTag status={invoiceItem?.ConfirmationCode} />
      </div>
    </>
  )

  // handleClose
  const handleClose = () => {
    setVisible(false)
    setInfoActiveTabViewPanelIndex(0)
  }

  // footer
  const footer = (
    <Button
      label={t('common.buttons.back')}
      icon="pi pi-check"
      onClick={handleClose}
      autoFocus
      className="mt-3 w-full md:w-auto"
    />
  )

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: '55rem' }}
      breakpoints={{ [calculateBreakpointWidth(55)]: '90vw' }}
      footer={footer}
      onHide={handleClose}
      blockScroll
    >
      <TabView activeIndex={infoActiveTabViewPanelIndex}>
        <TabPanel
          header={t('invoice.invoiceItems.table.info.dialog.form.title')}
        >
          <InfoForm
            currency={currency}
            invoiceItem={invoiceItem!}
            isLoading={isLoading}
          />
        </TabPanel>
        {config.invoice.infoInvoiceItem.allowanceCharges.enabled !== false && (
          <TabPanel
            header={t(
              'invoice.invoiceItems.table.info.dialog.allowanceCharges.title',
            )}
            disabled={!invoiceItem?.AllowanceCharges?.length}
          >
            <AllowanceCharges
              setInfoModus={setInfoModus}
              setDisplayInfoItem={setVisible}
              setDisplayInfoItemAllowanceCharge={
                setDisplayInfoItemAllowanceCharge
              }
              setIdInfoItemAllowanceCharge={setIdInfoItemAllowanceCharge}
              setInfoActiveTabViewPanelIndex={setInfoActiveTabViewPanelIndex}
              currency={currency}
              data={invoiceItem?.AllowanceCharges}
            />
          </TabPanel>
        )}
      </TabView>
    </Dialog>
  )
}
